import * as Html from "../../util/Html.ts";
import * as Redim from "../../lib/redim/imageRedim.js";
import * as Medias from "../../server/Medias.js";
import Icons from "../../svg/Icons.ts";

export {init}
Html.registerWidget('widget/form/input-image',{init:init})

function init(node){
  var 
    inputFile = node.find('input'),
    imgTag = node.find('img'),
    icon = node.find('icon'),
    isSmall = node.width()<80,
    nocontroll = node.attr("data-ui")==="nocontroll";
  
  node.addClass("input-image");
  
  if(!inputFile.prop('disabled') && !nocontroll){
    const commonStyle = isSmall?"padding:2px;width:16px;height:16px;line-height:16px;top:-6px;right:-6px":"zoom:85%;";
    node.append('<ib class="picture-delete" style="'+commonStyle+'">'+Icons.ic_close+'</ib>');
    node.append('<ib class="picture-reset"  style="'+commonStyle+'">'+Icons.ic_repeat+'</ib>');
  }
  var 
    deleteTag = node.find('.picture-delete'),
    resetTag = node.find('.picture-reset'),
    originalValue = node.attr("data-value")||inputFile.attr("data-value"),
    deletedValue = node.attr("data-default"),
    value = originalValue;
  
  
  function setPreview(thumb){
    value = thumb;
    if(isSmall){
      icon.toggle(thumb===null)
    }
    if(nocontroll){
      if(value){
        node.find('.input-controll').css("visibility","hidden");
      }else{
        node.find('.input-controll').css("visibility","visible");
      }
    }
    if(imgTag.length){
      if(value || deletedValue){
        imgTag.attr("src",value || deletedValue);
        imgTag.css("visibility","visible");
      }else{
        imgTag.css("visibility","hidden");
      }
    }else{
      if(value || deletedValue){
        node.css("background-position","50%");
        node.css("background-size","cover");
        node.css("background-image","url('"+(value || deletedValue)+"')");
      }else{
        node.css("background-image",'unset');
      }
    }
    
    deleteTag.toggle(value!==null);
    resetTag.toggle(value===null && !!originalValue);
    //IMPORTANT it is read by SRV to dectect that $empty should be sent
    inputFile.prop("empty",value===null);
  }
  setPreview(value||null);
  
  deleteTag.on("click",function(e){
    e.stopPropagation();
    e.preventDefault();
    inputFile.val('').trigger('change');
  });
  resetTag.on("click",function(e){
    e.stopPropagation();
    e.preventDefault();
    setPreview(originalValue);
  });
  inputFile.on('change',async function(){
    if(!await Medias.checkQuota()) return;
    if(!this.files[0]){
      setPreview(null);
      return;
    }
    Redim.thumbnail(this.files[0],{width:node.width(),height:node.height()},setPreview,setPreview)
  });
}


 